var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSpeaker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.13 0c2.597.604 4.537 2.987 4.537 5.833 0 2.847-1.94 5.23-4.537 5.834v-1.374c1.874-.572 3.24-2.352 3.24-4.46 0-2.107-1.366-3.887-3.24-4.46V0zM5.833.648v10.37l-3.24-3.24H0v-3.89h2.593v.001L5.833.65zM7.13 3.241c1.118.297 1.944 1.345 1.944 2.592 0 1.248-.826 2.296-1.944 2.593V3.24z",
    id: "a2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.167 1.167)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b2)",
    fill: "#4A4A4A"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.75,
    height: 57.75,
    rx: 4.667,
    transform: "translate(-14.583 -17.856)"
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#b2)",
    d: "M-1.167-1.167h14v14h-14z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpeaker);
export default __webpack_public_path__ + "static/media/icon-speaker.8907c1b4.svg";
export { ForwardRef as ReactComponent };